import React from "react"
import styled from "styled-components"

import Grid, { Col } from "components/grid"
import { Box } from "components/box"
import { H2, Eyebrow, LinkWithIcon } from "components/text"
import ImageSrcSet from "shared/image-content/image-srcset"

import { ImageAspect } from "pages/learn/learn-types"

const Container = styled(Box)`
  text-align: center;
  background: linear-gradient(to bottom, ${props => props.theme.colors.paleAqua} 70%, transparent 30%);
`

const Title = styled(H2)`
  line-height: 1.13;
  letter-spacing: -0.125rem;
`

type TopPanelProps = {
  section: string
  content: string
  imgSrc?: string
  imgAlt?: string
}

export const TopPanel: React.FC<TopPanelProps> = ({ section, content, imgSrc, imgAlt }) => (
  <Container pt={[7, null, 8]}>
    <Grid>
      <Col cols={[4, 4, 10, 8]} push={[0, 0, 1, 2]}>
        <Eyebrow color="evergreen">{section}</Eyebrow>
        <Title fontSize={["2.5rem", null, "4rem"]} my={[4, null, 5]}>
          {content}
        </Title>
        <LinkWithIcon iconName="arrowLeft" iconPosition="left" to="/learn">
          Back to blog
        </LinkWithIcon>
        {imgSrc && imgAlt && (
          <Box mt={[5, null, 6]}>
            <ImageSrcSet src={imgSrc} alt={imgAlt} aspect={ImageAspect.Landscape} />
          </Box>
        )}
      </Col>
    </Grid>
  </Container>
)
